import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const TRACKING_ID =  !process.env.NODE_ENV ||
process.env.NODE_ENV === "development" ||
(window.location.host !== "doxx.care" &&
  window.location.host !== "www.doxx.care")
  ? "" : 'WL8J22PSQW';

const firebaseConfig = {
  apiKey: "AIzaSyCa2A-ZFHPh-kzxinClJw-L1rKjNzx_Q_M",
  authDomain: "doxx-85cc4.firebaseapp.com",
  projectId: "doxx-85cc4",
  storageBucket: "doxx-85cc4.appspot.com",
  messagingSenderId: "901172558897",
  appId: "1:901172558897:web:cea96b7838b201fca8e910",
  measurementId:TRACKING_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
